var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c_table_wrap"},[_vm._v(" 사용내역 리스트 디폴트 레이아웃 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }